<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3 content-wrapper relative">
                    <div class="absolute right-6 top-3 cursor-pointer" @click="hide()">
                        <img class="w-4" src="@/assets/icon/ic-close.png" />
                    </div>
                    <div class="w-full text-center -mt-12">
                        <img class="w-20 m-auto" src="@/assets/icon/ic-success.png" />
                    </div>
                    <div class="text-24 text-tc-blue-2 text-center pt-4" v-if="title" v-html="title"></div>
                    <div class="text-center text-lg pb-5 pt-3">
                        <div v-if="isPrivilegeMessage"
                            v-html="privilegeMessage"></div>
                        <div v-if="isDelivery">
                            <div class="text-tc-gray-3 pt-4">{{lbl.detail.success_modal.redeem_date}} : <span class="text-tc-blue-2 pt-4">{{ campaign.redeemDate ? FiltertDateFormatShortMonth(campaign.redeemDate) : 'dd/mm/yyyy' }}</span></div>
                            <div v-html="deliveryMessage"></div>
                        </div>
                    </div>
                    <div class="px-9 mt-5 mx-auto">
                        <OutlineBlueBtn class="text-20" paddingClass="py-1" @click="goHistory()">{{lbl.detail.success_modal.my_reward}}</OutlineBlueBtn>
                        <BlueBtn class="w-full text-20" paddingClass="py-1 mt-4" @click="goCampaignList()">{{lbl.detail.success_modal.more_reward}}</BlueBtn>
                    </div>
                    <div class="flex pt-5">
                        <img class="mx-auto" src="@/assets/logo/buzzebees-logo-dark.svg" />
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import { CampaignType } from "@/helper/StaticValue.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import OutlineBlueBtn from '@/components/Button/OutlineBlueBtn.vue';
import BlueBtn from '@/components/Button/BlueBtn.vue';
export default {
    name: "DrawDeliveryModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components:{
        OutlineBlueBtn,
        BlueBtn
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            drawDeliveryModel: null,

            title: '',
            deliveryMessage: '',
            isDelivery: false,

            privilegeMessage: '',
            isPrivilegeMessage: false,
            campaign: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.drawDeliveryModel = config.drawDeliveryModel;
            this.campaign = config.campaign;
            this.initial();

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackClose();
        },

        initial: function () {
            console.log(this.drawDeliveryModel)
            if(this.drawDeliveryModel.privilegeMessage) {
                this.isPrivilegeMessage = true;
                this.privilegeMessage= this.drawDeliveryModel.privilegeMessage;
            } else {
                if(this.drawDeliveryModel.delivered == true) {
                    this.isDelivery = true;
                    this.title = this.lbl.detail.success_modal.title;
                    this.deliveryMessage= this.drawDeliveryModel.privilegeMessage;
                }

                if(this.drawDeliveryModel.type == CampaignType.Draw) {
                    this.isPrivilegeMessage = true;
                    this.privilegeMessage = this.getDrawMessage();
                }
            }
        },

        getDrawMessage: function () {
            let date = DatetimeHelper.getDatetimeFullFormat( this.drawDeliveryModel.campaignExpiredTimestamp);
            return Util.stringFormat(this.lbl.serial.draw, date);
        },
        goHistory: function() {
            this.$router.push('/history/redeem?tab=redeem');
        },
        goCampaignList: function() {
            this.$router.push('/privilege');
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
         @extend %modal;
        overflow: unset;

        @include mobile {
            top: auto;
        }
        .modal-content {
            width: 400px;
            overflow: unset;
            .content-wrapper {
                border-radius: 25px;
                @include mobile {
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;

                    width: 100%;
                }
            }
            @include mobile {
                width: 100%;
            }
        }
    }
</style>
